import number from '../../../../../../../shared/utils/formatting/number';

export const getOptionCountCopy = (count: number) => `(${number(count)})`;
